/* eslint-disable @typescript-eslint/ban-types */
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { parse } from "secure-json-parse";
import * as CryptoJS from "crypto-js";
import { decrypted } from "../../../../src/main";

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  public static readonly configPath = "config/config.json";
  //DatadogRUMInit; //MSAL V2
  public config: Record<string, unknown>;
  constructor(private http: HttpClient) {
    this.config = {};
  }

  /**
   * Use to get the data found in the second file (config file)
   */

  public getConfig(): object {
    return this.config;
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   *  for more https://juristr.com/blog/2018/01/ng-app-runtime-config/
   */
  public load(): Promise<boolean> {
    return new Promise((resolve) => {
      if (sessionStorage[AppConfigService.configPath]) {
        try {
          this.config = parse(
            sessionStorage[AppConfigService.configPath]
          ) as Record<string, unknown>;
          resolve(true);
          return;
        } catch (error) {
          // problem processing this - refresh the data
        }
      }
      this.http
        .get(AppConfigService.configPath)
        .pipe(
          take(1),
          catchError((err) => throwError(err || "Server error"))
        )
        .subscribe((configResponse: object) => {
          sessionStorage[AppConfigService.configPath] =
            JSON.stringify(configResponse);
          this.config = configResponse as Record<string, unknown>;
          resolve(true);
        });
    });
  }
  public DatadogRUMInit(clientToken, applicationId, site, service, env) {
    const d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];

    g.type = "text/javascript";

    g.async = true;

    g.defer = true;

    (g.innerHTML =
      "(function(h, o, u, n, d) { h = h[d] = h[d] || { q: [], onReady: function(c) { h.q.push(c);}}; " +
      "d = o.createElement(u); d.async = 1; d.src = n; n = o.getElementsByTagName(u)[0]; n.parentNode.insertBefore(d, n); " +
      "})(window, document, 'script', 'https://www.datadoghq-browser-agent.com/datadog-rum.js', 'DD_RUM'); " +
      " DD_RUM.onReady(function() { DD_RUM.init({ clientToken: '" +
      clientToken +
      "', applicationId: '" +
      applicationId +
      "', site: '" +
      site +
      "'," +
      " service: '" +
      service +
      "', env: '" +
      env +
      "', /* version: '1.0.0' ,*/ sampleRate: 100, trackInteractions: true, }); }); " +
      ' /*jslint bitwise: true */ function setCookie(e, r, i) { var t = new Date(); t.setTime(t.getTime() + 24 * i * 60 * 60 * 1e3); var d = "expires=" + t.toUTCString(); document.cookie = e + "=" + r + ";" + d + ";path=/;secure"; } ' +
      ' function getCookie(e) { for (var r = e + "=", i = document.cookie.split(";"), t = 0; t < i.length; t++) { for (var d = i[t]; " " == d.charAt(0);) d = d.substring(1); if (0 == d.indexOf(r)) return d.substring(r.length, d.length); } return "";} ' +
      'var dduserid = getCookie("_dduserid"); function uuidv4() { return "xxxx-xx-xx-xx-xxxxxx".replace(/[xy]/g, function(e) { var r = new Uint8Array(1), i = 1 * window.crypto.getRandomValues(r) | 0; return ("x" == e ? i : 3 & i | 8).toString(16); }); } ' +
      ' "" != dduserid || "" != (dduserid = uuidv4()) && null != dduserid && setCookie("_dduserid", dduserid, 30), DD_RUM.onReady(function() { DD_RUM.setUser({ id: dduserid }); });'),
      s.parentNode.insertBefore(g, s);
  }
}
